import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { POSTS } from "../data/blog";

export default function InsightsSection() {
  const posts = POSTS.slice(0, 3);

  return (
    <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36" data-testid="insights-section">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
        <Reveal>
          <p className="text-sm text-neutral-400 mb-6">Insights</p>
          <h2 className="font-display text-4xl md:text-6xl tracking-tighter font-medium leading-[0.98] max-w-2xl">
            The playbook for modern real estate operations.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Link to="/blog" className="inline-flex items-center gap-2 text-neutral-600 hover:text-black transition-colors" data-testid="insights-all">
            All insights <ArrowRight size={18} />
          </Link>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-px bg-black/10 border border-black/10 rounded-3xl overflow-hidden">
        {posts.map((post, i) => (
          <Reveal key={post.slug} delay={i * 0.08}>
            <Link to={`/blog/${post.slug}`} className="group flex h-full flex-col bg-white p-8 md:p-10 transition-colors duration-500 hover:bg-[#0a0a0a] hover:text-white" data-testid={`insight-${i}`}>
              <div className="flex items-center gap-3 text-sm text-neutral-400 group-hover:text-neutral-400">
                <span>{post.readTime}</span>
              </div>
              <h3 className="mt-6 font-display text-2xl tracking-tight font-medium leading-tight">{post.title}</h3>
              <p className="mt-4 text-neutral-500 group-hover:text-neutral-300 leading-relaxed transition-colors line-clamp-3">{post.excerpt}</p>
              <span className="mt-8 inline-flex items-center gap-2 text-neutral-500 group-hover:text-white transition-colors">
                Read <ArrowUpRight size={17} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
